import auth from '../auth';
import config from '../config';
import { NewRelicLogLevel } from '../newRelicHelper';

export const DEFAULT_TAGS = {
  'tags.contact': 'blazarsquaddev',
  'tags.domain': 'artwork-technology',
  'tags.product': 'template-management',
  'tags.service': 'localization-ui',
  'tags.environment': config.threeLetterEnvironment,
  'tags.region': 'eu-west-1',
  'tags.team': 'blazar',
};

function getUserCanonicalId() {
  const profile = auth.getProfile();
  return (profile ?? {})['https://claims.cimpress.io/canonical_id'] ?? '(Unknown User ID)';
}

function constructError(error: any): Error {
  const errorObj: Error = { ...error };

  return errorObj;
}

function log(newRelicLogLevel: NewRelicLogLevel, message: string, error?: any): void {
  if (error) {
    window.newrelic?.log(message, {
      customAttributes: {
        ...DEFAULT_TAGS,
        userId: getUserCanonicalId(),
        cause: constructError(error),
      },
      level: newRelicLogLevel,
    });
  } else {
    window.newrelic?.log(message, {
      customAttributes: {
        ...DEFAULT_TAGS,
        userId: getUserCanonicalId(),
      },
      level: newRelicLogLevel,
    });
  }
}

export function logDebug(message: string) {
  return log(NewRelicLogLevel.DEBUG, message);
}

export function logWarning(message: string, error: any) {
  return log(NewRelicLogLevel.WARN, message, error);
}

export function logError(message: string, error: any) {
  return log(NewRelicLogLevel.ERROR, message, error);
}

export function logInfo(message: string) {
  return log(NewRelicLogLevel.INFO, message);
}

export default {
  logError: logError,
};
